import React from 'react';
import { isEN } from "../../../../../_util/locale";

import './index.less';

import principalEn from '../principal_en.png';
import principalZh from '../principal_zh.png';

interface ITagProps {
  customStyle?: any;
  isPublic?: boolean;
}
const PrincipalTag = (props: ITagProps) => {
    return <img src={isEN() ? principalEn : principalZh} className={'tag'} style={props.customStyle} />;
};

export default PrincipalTag;
